
export default {
  data() {
    return {
      options: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },
        {
          name: 'subtitle',
          label: 'Podnaslov',
          type: 'textarea',
        },
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
          size: '400x400',
        },
      ],
      optionsFood: [
        {
          name: 'food',
          label: 'Hrana',
          type: 'text',
        },
        {
          name: 'price',
          label: 'Cijena',
          type: 'text',
        },
      ],
    }
  },
}
